import {FC} from 'react'
import {KTCard} from '../../../_metronic/helpers'
import {AccessPageTitle} from '_metronic/layout/core/AccessPageData'
import {AccessReview} from './AccessReview'
import {ToastContainer} from 'react-toastify'

const AccessReviewWrapper: FC = () => {
  return (
    <>
      <AccessPageTitle
        icon='user-access.svg'
        title='User Review'
        desc='Review access on your critical systems and applications'
      >
        User Access
      </AccessPageTitle>
      <KTCard>
        <AccessReview className='mb-5 mb-xl-8' />
      </KTCard>
      <ToastContainer />
    </>
  )
}

export default AccessReviewWrapper
